import { Link } from "react-router-dom";
import Reveal, { Eyebrow } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { IMAGES } from "@/data/site";

export default function BrandIntro() {
  const { t } = useLanguage();
  return (
    <section className="py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 lg:grid-cols-2 lg:gap-20 lg:px-10">
        <Reveal>
          <Eyebrow>{t.intro.eyebrow}</Eyebrow>
          <h2 className="mt-6 font-serif text-4xl leading-[1.1] text-cream sm:text-5xl lg:text-6xl">
            {t.intro.heading.split(".")[0]}.
            <span className="gold-text block italic">
              {t.intro.heading.split(".")[1] ? `${t.intro.heading.split(".")[1]}.` : ""}
            </span>
          </h2>
          <p className="mt-7 max-w-lg text-base leading-relaxed text-cream/70 sm:text-lg">
            {t.intro.body}
          </p>
          <Link
            to="/about"
            data-testid="intro-discover-button"
            className="mt-9 inline-flex items-center gap-3 border border-gold/50 px-7 py-3.5 text-sm font-medium uppercase tracking-[0.15em] text-gold transition-all duration-300 hover:border-gold hover:bg-gold/10"
          >
            {t.intro.cta}
          </Link>
        </Reveal>

        <Reveal delay={0.15} className="relative">
          <div className="absolute -inset-3 border hairline md:-inset-5" aria-hidden="true" />
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={IMAGES.intro}
              alt={t.intro.imgAlt}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out hover:scale-[1.04]"
            />
          </div>
          <div className="absolute -bottom-6 left-6 border hairline bg-obsidian px-6 py-4 shadow-[0_0_40px_rgba(212,175,55,0.12)] md:left-10">
            <p className="font-serif text-2xl italic text-gold">{t.intro.badge}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
